"use strict";

exports.__esModule = true;
exports.ChartTypeSelector = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Translator = require("../../Core/Translator");
var _constants = require("../../Recharts/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ChartTypeSelector = exports.ChartTypeSelector = function ChartTypeSelector(props) {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("DataItem.chartType.label", "Chart Type"),
    helperText: translate("DataItem.chartType.helperText", "The type of chart to show.")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.HTML_SELECT
  }, /*#__PURE__*/_react["default"].createElement("select", {
    "data-testid": "chart-type-selector",
    value: element.props.chartType || _constants.LINE_CHART,
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "chartType", e.target.value || undefined);
    }
  }, /*#__PURE__*/_react["default"].createElement("option", {
    value: _constants.LINE_CHART
  }, translate("DataItem.chartType.lineChart.label", "Line Chart")), /*#__PURE__*/_react["default"].createElement("option", {
    value: _constants.SCATTER_CHART
  }, translate("DataItem.chartType.scatterPlotChart.label", "Scatter Plot Chart")))));
};